import React from 'react';

import Button from 'components/shared/Button/Button';

const RING_SIZE = 64;
const RING_STROKE = 6;
const RING_RADIUS = (RING_SIZE - RING_STROKE) / 2;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

const CountdownRing = ({ remaining, total }) => {
  const progress = total > 0 ? Math.max(remaining, 0) / total : 0;

  return (
    <div
      className="relative flex h-16 w-16 shrink-0 items-center justify-center"
      aria-hidden="true">
      <svg width={RING_SIZE} height={RING_SIZE} className="-rotate-90">
        <circle
          cx={RING_SIZE / 2}
          cy={RING_SIZE / 2}
          r={RING_RADIUS}
          fill="none"
          strokeWidth={RING_STROKE}
          className="stroke-primary-50"
        />
        <circle
          cx={RING_SIZE / 2}
          cy={RING_SIZE / 2}
          r={RING_RADIUS}
          fill="none"
          strokeWidth={RING_STROKE}
          strokeLinecap="round"
          strokeDasharray={RING_CIRCUMFERENCE}
          strokeDashoffset={RING_CIRCUMFERENCE * (1 - progress)}
          className="stroke-primary-500 transition-[stroke-dashoffset] duration-1000 ease-linear motion-reduce:transition-none"
        />
      </svg>
      <span className="absolute text-xl font-600 text-primary-900">{Math.max(remaining, 0)}</span>
    </div>
  );
};

// A non-modal countdown: no backdrop and no focus trap, so the screen stays visible and
// usable behind it. Any touch anywhere counts as activity and dismisses it.
const IdleCountdownOverlay = ({ isOpen, remaining, total, message, onStay }) => {
  if (!isOpen) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[300] flex justify-center px-4 pb-6 xs:pb-4">
      <div
        role="alertdialog"
        aria-modal="false"
        aria-labelledby="idle-countdown-title"
        aria-describedby="idle-countdown-message"
        className="pointer-events-auto flex w-full max-w-[600px] animate-enter-up items-center gap-5 rounded-2xl border border-solid border-primary-100 bg-white p-5 shadow-[0_20px_50px_-12px_rgba(2,28,44,0.4)] xs:flex-col xs:gap-4 xs:text-center">
        <CountdownRing remaining={remaining} total={total} />
        <div className="flex flex-1 flex-col gap-1">
          <p id="idle-countdown-title" className="text-xl font-600 text-primary-900">
            Are you still there?
          </p>
          <p id="idle-countdown-message" className="text-base text-neutral-600">
            {message}
          </p>
        </div>
        <Button
          size="large"
          text="I'm still here"
          className="h-14 shrink-0 rounded-xl xs:w-full"
          textClassName="text-lg"
          onClick={onStay}
        />
      </div>
    </div>
  );
};

export default IdleCountdownOverlay;
